import webApi from '../../WebApi/WebApi';


//Anti Money list
export const getAllAntiMoneyList = async () => {
    return await webApi.get(`/info-pages/slug/anti-money-laundering-and-terrorist-financing-policy`);
}